<template>
  <div>
    <div class="yuliang" ref="yuliang">
      <div class="select">
        <span class="desc">起止年份:</span>
        <div class="block" style="display: inline-block;">
          <el-date-picker
            v-model="beginDate"
            type="year"
            value-format="yyyy"
            placeholder="开始年份"
            :picker-options="Global.pickerOptionsStart(endDate)"
            :clearable="false"
            :editable="false"
          ></el-date-picker>
        </div>
        <span style="margin: 0 5px;">至</span>
        <div class="block" style="display: inline-block;">
          <el-date-picker
            v-model="endDate"
            type="year"
            value-format="yyyy"
            placeholder="结束年份"
            :picker-options="Global.pickerOptionsEnd(beginDate)"
            :clearable="false"
            :editable="false"
          ></el-date-picker>
        </div>
        <span id="select" @click="searchyear">查询</span>
        <span @click="exportdata" id="export">
          <span class="export-icon"></span>导出
        </span>
      </div>
      <div class="raintable" ref="rttable">
        <u-table
          use-virtual
          :excess-rows="5"
          :row-height="48"
          highlight-current-row
          v-loading="loading"
          :data="tdata"
          :max-height="height"
          border
           v-if="tableShow"
          style="width: 100%;"
          :default-sort ="{prop:'ljyl',order:'descending'}"
        >
          <u-table-column
            fixed
            type="index"
            width="60"
            label="序号"
            align="center"
            header-align="center"
          ></u-table-column>
          <u-table-column prop="addvnm" label="乡镇" sortable width="150" header-align="center"></u-table-column>
          <u-table-column prop="stnm" label="站名" sortable width="150" header-align="center">
            <template slot-scope="scope">
              <el-tooltip effect="dark" :content="scope.row.stnm + ' ' + (scope.row.stcd?scope.row.stcd:'')" placement="top" class="item" popper-class="hiddenOverflow">
                <span style="cursor:pointer!important;" >{{ scope.row.stationName }}</span>
              </el-tooltip>
            </template>
          </u-table-column>
          <u-table-column prop="ljyl" sortable label="累计" width="90" align="center" header-align="center">
            <template slot-scope="scope">
              <span>{{formatTableCellValue(scope.row['oldljyl'])}}</span>
            </template>
          </u-table-column>
          <u-table-column
            v-for="(item,index) in thedate"
            :key="index"
            :label="item"
            :prop="item"
            sortable
            header-align="center"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span>{{formatTableCellValue(scope.row['old'+item])}}</span>
            </template>
          </u-table-column>
        </u-table>
      </div>
    </div>
    <el-dialog :title="thestation" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <div id="station"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import monitorTypes from '@/store/types/monitor'
export default {
  name: 'MonitoringCenter',
  data () {
    return {
      loading: true,
      height: 10,
      sID: '22',
      sTID: '',
      beginDate: '',
      endDate: '',
      stationName: '',
      isTown: true,
      searchName: '',
      tdata: [],
      all: true,
      adcdtotal: '',
      pageIndex: 1,
      pageSize: 100,
      towns: [],
      checkarr: [],
      datenum: '',
      thedate: [],
      dialogVisible: false,
      thestation: '',
      yearvalue1: '',
      yearvalue2: '',
      tableShow: true
    }
  },
  computed: {},
  methods: {
    sortChange1 (a, b) {
      let avalue
      let bvalue
      a.forEach(item => {
        let data = item.data
        data.forEach(it => {
          avalue = it.value
        })
      })
      b.forEach(item => {
        let data = item.data
        data.forEach(it => {
          bvalue = it.value
        })
      })
      return avalue - bvalue
    },
    stationchart (data) {
      this.thestation = data
      this.dialogVisible = true
      this.drawChart()
    },
    // 获取数据
    tabledata () {
      this.loading = true
      this.$store
        .dispatch(monitorTypes.GET_YEARLY_RAINFALL, {
          sID: this.sID,
          sTID: this.sTID,
          beginDate: this.beginDate,
          endDate: this.endDate,
          mainStation: true
        })
        .then(data => {
          this.tdata = []
          this.tableShow = false
          this.$nextTick(() => {
            this.tableShow = true
            this.$set(this, 'tdata', data.rows)
            this.tdata.forEach(element => {
              element.data.forEach(item => {
                let date = ''
                if (item.date === '累计雨量') {
                  date = 'ljyl'
                } else {
                  date = item.date
                }
                element[date] = this.getTableCellValue(item.value_Str)
                element['old' + date] = item.value_Str
              })
            })
          })
          // this.tdata = data.rows
          // this.$refs.plTable.reloadData(this.tdata) // 表格滚动优化
          this.loading = false
        })
    },
    getTableCellValue: function (val) {
      let result = 0
      if (val !== undefined && val !== '') {
        result = Number(val)
      }
      return result
    },
    formatTableCellValue (val) {
      let result = val
      if (val === undefined || val === '') {
        result = '-'
      }
      return result
    },
    searchyear () {
      this.thedate = []
      let start = parseInt(this.beginDate)
      let end = parseInt(this.endDate)
      for (let index = start; index <= end; index++) {
        this.thedate.push(index.toString())
      }
      this.tabledata()
    },
    // 获取当前年份设置开始年份与结束年份
    getdate: function () {
      let date = new Date()
      this.beginDate = (date.getFullYear() - 1).toString()
      this.endDate = date.getFullYear().toString()
    },
    // 选择开始年份
    selectedBeginYear (val) {
      this.beginDate = val
    },
    // 选择结束年份
    selectedEndYear (val) {
      this.endDate = val
    },
    exportdata () {
      this.$store
        .dispatch(monitorTypes.EXPORT_RAINSTATIS_YEARLY, {
          sID: this.sID,
          sTID: this.sTID,
          beginDate: this.beginDate,
          endDate: this.endDate,
          mainStation: true
        })
        .then(data => {
          window.location.href = this.Global.basePath + data.data
          // window.location.href
        })
    }
  },
  created () {
    this.getdate()
    this.searchyear()
  },
  mounted () {
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height =
        contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45 + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height =
        this.$refs['yuliang'].offsetHeight - selectDiv[0].offsetHeight - 20
    })
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style scoped>
.yuliang >>> .el-date-editor.el-input,
.yuliang >>> .el-date-editor.el-input__inner {
  width: 130px;
}
#station {
  width: 500px;
  height: 300px;
}
</style>
